import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const AnonymousModalIcon = styled.img<React.CSSProperties>`
  height: ${84 * Screen.widthRatio}px;
  width: ${84 * Screen.widthRatio}px;
`;

export default withImage(AnonymousModalIcon);
